import { inject, Service } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MngIconDef } from './mng-icon.types';
import { firstValueFrom } from 'rxjs';

const SINGLE_ICONS: MngIconDef[] = [
  // { iconName: 'account-arrow-right-outline', iconUrl: 'assets/icons/account-arrow-right-outline.svg' }
];

export interface ISvgIcons {
  [iconName: string]: SVGElement;
}

@Service()
export class MngIconService {
  iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  initializeIcons(): void {
    this.registerSvgIcons(SINGLE_ICONS);
    this.iconRegistry.addSvgIconSet(this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-icons.svg'));
    this.iconRegistry.addSvgIconSetInNamespace(
      'merkur',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/merkur-icons.svg')
    );
  }

  registerSvgIcons(defs: MngIconDef[]): void {
    defs.forEach((def: MngIconDef) => {
      this.registerSvgIcon(def);
    });
  }

  registerSvgIcon(def: MngIconDef) {
    if (def.namespace) {
      this.iconRegistry.addSvgIconInNamespace(
        def.namespace,
        def.iconName,
        this.sanitizer.bypassSecurityTrustResourceUrl(def.iconUrl)
      );
    } else {
      this.iconRegistry.addSvgIcon(def.iconName, this.sanitizer.bypassSecurityTrustResourceUrl(def.iconUrl));
    }
  }

  async resolveSvgIcons(...iconNames: string[]): Promise<ISvgIcons> {
    const iconResolver = async (iconName: string) => {
      try {
        return await firstValueFrom(this.iconRegistry.getNamedSvgIcon(iconName));
      } catch (e) {
        console.error('can not resolve icon', iconName, e);
        return undefined;
      }
    };

    const promises = iconNames.map((iconName) => iconResolver(iconName));

    try {
      const resolved = await Promise.all(promises);

      const result: ISvgIcons = {};

      iconNames.forEach((iconName: string, index) => {
        const svg = resolved[index];
        if (!svg) {
          console.error('SVG icon', iconName + ' konnte nicht ermittelt werden');
        }
        result[iconName] = svg;
      });
      return result;
    } catch (e) {
      console.error(e);
      return {};
    }
  }
}
